module.exports = __webpack_public_path__ + "img/E0.1548fb85.png";